import api from '@/api'
import { login, getPermission } from '@/api/admin'
import { getVpnList } from '@/api/setting'

const state = () => ({
    account: localStorage.account || '',
    token: localStorage.token || '',
    failure_time: localStorage.failure_time || '',
    networkStatus: { 'online': 0, 'offline': 0 },
    permissions: []
})

const getters = {
    isLogin: state => {
        let retn = false
        if (state.token) {
            if (new Date().getTime() < state.failure_time * 1000) {
                retn = true
            }
        }
        return retn
    }
}

const actions = {
    login({ commit }, data) {
        return new Promise((resolve, reject) => {
            login({ username: data.account, password: data.password }).then(res => {
                commit('setUserData', {
                    account: data.account,
                    token: res.data.token,
                    failure_time: Math.ceil(new Date().getTime() / 1000) + 24 * 60 * 60 * 3 // 三天过期时间
                })
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },
    logout({ commit }) {
        commit('removeUserData')
        commit('menu/invalidRoutes', null, { root: true })
        commit('menu/removeRoutes', null, { root: true })
    },
    // 获取我的权限
    getPermissions({ commit }) {
        return new Promise(resolve => {
            // 通过 mock 获取权限
            // api.get('member/permission', {
            //     baseURL: '/mock/',
            //     params: {
            //         account: state.account
            //     }
            // }).then(res => {
            //     commit('setPermissions', res.data.permissions)
            //     resolve(res.data.permissions)
            // })
            getPermission({}).then(res => {
                if (res.data && Array.isArray(res.data.resrcDirList)) {
                    // 获取所有属于新添加的目录
                    const menus = res.data.resrcDirList.filter(item => { return item.num.indexOf('rs_') !== -1 })
                    let permissions = []
                    menus.map(item => {
                        // rs_new_ 为新加目录标识
                        const permission = item.num.split('rs_')[1].split('_').join('.')
                        permissions.push(permission)
                        if (Array.isArray(item.resrcMenuList) && item.resrcMenuList.length) {
                            item.resrcMenuList.map(i => {
                                const perm = i.num.split('rs_')[1].split('_').join('.')
                                permissions.push(perm)
                            })
                        }
                    })
                    commit('setPermissions', permissions)
                    resolve(permissions)

                }
            })

        })
    },
    editPassword({ state }, data) {
        return new Promise(resolve => {
            api.post('member/edit/password', {
                account: state.account,
                password: data.password,
                newpassword: data.newpassword
            }, {
                baseURL: '/mock/'
            }).then(() => {
                resolve()
            })
        })
    },
    getNetworkStatus({ commit }) {
        return new Promise(resolve => {
            getVpnList({}).then(res => {
                const { records = [] } = res
                const status = { 'online': 0, 'offline': 0 }
                records.map(item => {
                    item.status ? status.online++ : status.offline++
                })
                commit('setNetworkStatus', status)
                resolve(res)
            })
        })
    }
}

const mutations = {
    setUserData(state, data) {
        localStorage.setItem('account', data.account)
        localStorage.setItem('token', data.token)
        localStorage.setItem('failure_time', data.failure_time)
        state.account = data.account
        state.token = data.token
        state.failure_time = data.failure_time
    },
    removeUserData(state) {
        localStorage.removeItem('account')
        localStorage.removeItem('token')
        localStorage.removeItem('failure_time')
        state.account = ''
        state.token = ''
        state.failure_time = ''
    },
    setPermissions(state, permissions) {
        state.permissions = permissions
    },
    setNetworkStatus(state, status) {
        state.networkStatus = status
    }
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
